import React from 'react';
import { FormattedMessage } from 'react-intl';

export const readMore = (
    <FormattedMessage id="PdpSharedDealerDetails.readMore" defaultMessage="Read More" />
);

export const aboutSeller = (
    <FormattedMessage id="PdpSharedDealerDetails.aboutSeller" defaultMessage="About the Seller" />
);

export const close = (
    <FormattedMessage id="PdpSharedDealerDetails.closeButton" defaultMessage="Close" />
);
